import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { InfoOutlinedIcon } from '../icons/infoOutlinedIcon';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  line-height: 1em;
`;
const INLINE_CONTAINER_CSS = css(CONTAINER_CSS, css `
    display: inline-flex;
  `);
export const IconWithLabelDisplay = ({ icon = _jsx(InfoOutlinedIcon, {}), label, isSubtle, isAlert, color, isInline }) => {
    const styleProps = {
        ...(isAlert ? { color: '#AA0000' } : {}),
        ...(color ? { color } : {}),
        ...(isSubtle ? { opacity: 0.4 } : {})
    };
    return isInline ? (_jsxs("span", { css: INLINE_CONTAINER_CSS, style: styleProps, children: [icon, " ", label] })) : (_jsxs("div", { css: CONTAINER_CSS, style: styleProps, children: [icon, " ", label] }));
};
